import axios from 'axios';
import { serverUrl } from '../../server';
import Cookies from 'js-cookie';

const token = Cookies.get('jwt')

export function getTracteur(id) {
  return axios.get(`${serverUrl}/api/tracteur/gettracteur/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function getTracteurs() {
  var prestataire_id = -1
  if(arguments.length > 0) { prestataire_id = arguments[0]; }
  return axios.get(`${serverUrl}/api/tracteur/gettracteurs`, {
    params: { prestataire_id: prestataire_id },
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.tracteurs)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function updateTracteur(id, data) {
  return axios.put(`${serverUrl}/api/tracteur/updatetracteur/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function deleteTracteur(id) {
  return axios.delete(`${serverUrl}/api/tracteur/deletetracteur/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function getTracteurByPrestataire(prestataire_id) {
  return axios.get(`${serverUrl}/api/tracteur/gettracteurbyprestataire/${prestataire_id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.tracteurs)
    .catch(error => {
      console.error(error);
      throw error;
    });
} 

export function countTracteurs() {
  return axios.get(`${serverUrl}/api/tracteur/counttracteurs`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.total)
    .catch(error => {
      console.error(error);
      throw error;
    });
}       